module.exports = __webpack_public_path__ + "img/reifentechnik_fuer_fortgeschrittene_784x514.c4ce55f2.jpg";